import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicTextArea, BasicInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function RoleEditTemplate({ editView }) {
    const {
        contentLoading,
        form,
        isEdit
    } = editView;

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} disabled={isEdit} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicTextArea field={form.$('description')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

RoleEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(RoleEditTemplate);
